export class NwbVersion {
  constructor(
    public readonly id: number,
    public readonly retrieveDate: Date,
    public readonly mapId: number,
    public readonly containerName: string,
    public readonly blobName: string
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/nwbversion.model.ts